import { numberFormatUtils } from '@instinet-analytics/core-lib';
import ColumnType from './ColumnType';
import ColumnPortfolio, { BlotterColumn } from './ColumnPortfolio';
import { IndigoAppContextType } from 'app/AppContext';
import { EnumMap } from '@instinet-analytics/core-lib';
import { ValueType } from '@instinet-analytics/semantic-ui-components';
import { timeFormatUtils } from '@instinet-analytics/core-lib';

const {
    toDate,
    toDateTime,
    toDateTimeSeconds,
    toTimeMinutes,
    toTimeSeconds,
    toTimeMilliseconds,
} = timeFormatUtils;
const { N0, N1, N2, N4 } = numberFormatUtils;

interface ColumnFilterProps {
    valueType: ValueType;
    precision?: number;
    enumMap?: EnumMap;
}

type ColumnFilterPropsMap = {
    [key in BlotterColumn]: ColumnFilterProps;
};

function mapColumnToFilterProps(
    columnPortfolio: ColumnPortfolio,
    blotterColumn: BlotterColumn
) {
    const column = columnPortfolio[blotterColumn];
    switch (column.colType) {
        case ColumnType.CURRENCY:
            return {
                valueType: ValueType.CURRENCY,
                precision: getPrecision(column.colFmt),
            };
        case ColumnType.CURRENCYPRICE:
            return {
                valueType: ValueType.CURRENCY,
                precision: 2, // Note https://jira.isn.instinet.com:8443/browse/IND2-2649: may need to enhance this to consider tick size
            };
        case ColumnType.PRICE:
            return {
                valueType: ValueType.NUMBER,
                precision: 2, // Note https://jira.isn.instinet.com:8443/browse/IND2-2649: may need to enhance this to consider tick size
            };
        case ColumnType.INTEGER:
        case ColumnType.NUMBER:
            return {
                valueType: ValueType.NUMBER,
                precision: getPrecision(column.colFmt),
            };
        case ColumnType.ENUM:
        case ColumnType.DAY_ENUM:
            return {
                valueType: ValueType.ENUM,
                enumMap: column.enumMap,
            };
        case ColumnType.DATE:
            switch (column.labelFunction) {
                case toTimeMinutes:
                case toTimeSeconds:
                case toTimeMilliseconds:
                    return {
                        valueType: ValueType.TIME,
                    };
                case toDate:
                    return {
                        valueType: ValueType.DATE,
                    };
                case toDateTime:
                case toDateTimeSeconds:
                default:
                    return {
                        valueType: ValueType.DATETIME,
                    };
            }
        case ColumnType.STRING:
        default:
            return {
                valueType: ValueType.STRING,
            };
    }
}

export const columnFilterPropsMap: (
    columnPortfolio: ColumnPortfolio
) => ColumnFilterPropsMap = (columns) =>
    Object.keys(columns).reduce((filterProps, key) => {
        filterProps[key as BlotterColumn] = mapColumnToFilterProps(
            columns,
            key as BlotterColumn
        );
        return filterProps;
    }, {} as ColumnFilterPropsMap);

export function getPrecision(
    colFmt?: (context: IndigoAppContextType, value: number) => string
): number {
    switch (colFmt) {
        case N4:
            return 4;
        case N2:
            return 2;
        case N1:
            return 1;
        case N0:
        default:
            return 0;
    }
}
